// extensions/PreventFirstBulletDelete.js
import { Extension } from '@tiptap/core'

export const PreventBackspace = Extension.create({
  name: 'preventBackspace',

  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const { state, view } = editor
        const { $from } = state.selection
        
        let index = 0
        if ($from.node($from.depth - 1).type.name == 'listItem'){
          const listNode = $from.node($from.depth - 1)
          const listPos = $from.before($from.depth - 1)
                      
          listNode.forEach((child, offset) => {
            if (offset < $from.before($from.depth) - listPos) {
                index++
            }
          })
        }
        if(index > 1){
          return false; // not first bullet point allow
        }
      
        if ($from.parent.type.name !== 'paragraph' || $from.parentOffset !== 0) {
          return false // Not at beginning of paragraph — allow
        }

        const listItemNode = $from.node($from.depth - 1)
        if (listItemNode.type.name !== 'listItem') {
          return false // Not inside listItem — allow
        }
        
        const bulletListNode = $from.node($from.depth - 2)
        if (bulletListNode.type.name !== 'bulletList') {
          return false // Not inside bulletList — allow
        }

        const listItem = $from.parent
        const isEmpty = listItem.content.size === 0
        const isAtStart = $from.parentOffset === 0
        const docFirstNode = state.doc.firstChild

         const isFirstListItem =
          bulletListNode.content.firstChild === listItemNode

        if (bulletListNode == docFirstNode && isFirstListItem) {
          return true //  Prevent backspace in first list item
        }

        //remove newline when deleting bullet
        if (isEmpty && isAtStart) {
          const listItemDepth = $from.depth
          const start = $from.before(listItemDepth)
          const end = $from.after(listItemDepth)

          const tr = state.tr.deleteRange(start, end)
          view.dispatch(tr.scrollIntoView())
          return true
        }     
        
        return false;
      },

      Enter: ({ editor }) => {
        const { state } = editor
        const { $from } = state.selection
        
        let index = 0
        if ($from.node($from.depth - 1).type.name == 'listItem'){
          const listNode = $from.node($from.depth - 1)
          const listPos = $from.before($from.depth - 1)
                      
          listNode.forEach((child, offset) => {
            if (offset < $from.before($from.depth) - listPos) {
                index++
            }
          })
        }
        if(index > 1){
            return false; // not first bullet point allow
        }
        if ($from.parent.type.name !== 'paragraph' || $from.parentOffset !== 0) {
          return false // Not at beginning of paragraph — allow
        }

        const listItemNode = $from.node($from.depth - 1)
        if (listItemNode.type.name !== 'listItem') {
          return false // Not inside listItem — allow
        }

        const bulletListNode = $from.node($from.depth - 2)
        if (bulletListNode.type.name !== 'bulletList') {
          return false // Not inside bulletList — allow
        }

        const docFirstNode = state.doc.firstChild
        if (bulletListNode !== docFirstNode) {
          return false // Bullet list is not the first node in document — allow
        }

       const isFirstListItem =
          bulletListNode.content.firstChild === listItemNode

        if (isFirstListItem) {
          return true //  Prevent backspace in first list item
        }

        return false
    },
    }
  },
})
